import React, { createContext, useContext, useState, useEffect, useRef, useCallback } from 'react';
import { useAuth } from '../context/AuthContext';
import { useLocation } from 'react-router-dom';

const AdContext = createContext({ ads: {}, fullpageAd: null, dismissFullpage: () => {} });

export function useAds() {
  return useContext(AdContext);
}

export default function AdProvider({ children }) {
  const { apiFetch } = useAuth();
  const location = useLocation();
  const [ads, setAds] = useState({});
  const [fullpageAd, setFullpageAd] = useState(null);
  const fetchedRef = useRef(false);
  const prevPathRef = useRef(location.pathname);

  // Fetch active ads once on mount
  useEffect(() => {
    if (fetchedRef.current) return;
    fetchedRef.current = true;
    apiFetch('/api/ads/active').then(data => setAds(data.ads || {})).catch(() => {});
  }, [apiFetch]);

  // Track page loads on navigation changes
  const trackPageLoad = useCallback(() => {
    apiFetch('/api/ads/page-load', { method: 'POST' })
      .then(data => {
        if (data.showFullpage && data.ad) setFullpageAd(data.ad);
      })
      .catch(() => {});
  }, [apiFetch]);

  // Initial page load
  useEffect(() => {
    trackPageLoad();
  }, []); // eslint-disable-line

  // Subsequent navigations
  useEffect(() => {
    if (prevPathRef.current !== location.pathname) {
      prevPathRef.current = location.pathname;
      trackPageLoad();
    }
  }, [location.pathname, trackPageLoad]);

  const dismissFullpage = () => setFullpageAd(null);

  return (
    <AdContext.Provider value={{ ads, fullpageAd, dismissFullpage }}>
      {children}
    </AdContext.Provider>
  );
}
